module.exports = __webpack_public_path__ + "img/cb-logo.8f5d09b0.png";